import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Language } from 'app/model/constant';
import { Remark } from 'app/model/products/product-detail-info.model';
import { AppConfigService } from 'app/services/app-config/app-config.service';

@Component({
  selector: 'act-dialog-information-cart',
  templateUrl: './dialog-information-cart.component.html',
  styleUrls: ['./dialog-information-cart.component.scss']
})
export class DialogInformationCartComponent implements OnInit {

  public form: FormGroup;
  public isSubmitted = false;
  public lang = Language.en;
  public pageElementName = 'remark-cart-dialog';

  constructor(
    private fb: FormBuilder,
    private appConfigService: AppConfigService,
    @Inject(MD_DIALOG_DATA) public data: {
      remark: Remark[]
    },
    private dialogRef: MdDialogRef<DialogInformationCartComponent>,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      acceptTerms: [false, [Validators.requiredTrue]],
    });
    this.lang = this.appConfigService.getLanguage();
  }

  onCancel() {
    this.dialogRef.close({ event: 'fail' });
  }

  onConfirm() {
    this.isSubmitted = true;
    if (this.form.valid) {
      this.dialogRef.close({ event: 'success' });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-information-cart/dialog-information-cart.component.ts